import * as THREE from 'three'
import { types } from 'mobx-state-tree'
import {
  generateNodeType,
  generateType
} from 'src/api/models/utils/generateNodeType'
import { project, projectProperties } from 'src/constants/typenames'
import { ContentConnection } from 'src/api/models/Content'
import { EnclosureConnection } from 'src/api/models/Enclosure'
import { AccessoryConnection } from 'src/api/models/Accessories'
import { FastenerConnection } from 'src/api/models/Fastener'
import { StringValue } from 'src/api/models/values'
import { contentLimits } from 'src/constants/parameters'
import { IProject, IGetTotalLimit } from './types'

const ProjectModel: IProject = generateNodeType(project)
  .props({
    properties: types.optional(
      generateType(projectProperties).props({
        name: StringValue,
        description: types.optional(StringValue, { value: '' })
      }),
      { name: { value: '' }, description: { value: '' } }
    ),
    content: types.optional(ContentConnection, {}),
    // @ts-ignore
    enclosure: types.optional(EnclosureConnection, {} as any),
    accessories: types.optional(AccessoryConnection, {}),
    fasteners: types.optional(FastenerConnection, {})
  })
  .views((self) => ({
    get boundings() {
      return self.enclosure.coverEdges[0].node.boundings as THREE.Box3
    },
    getTotalLimit({
      currentValue,
      dimension,
      layer = 'content'
    }: Parameters<IGetTotalLimit>[0]) {
      const { min, max } = contentLimits[dimension] // 36 240
      const clearSize = self[layer].edges[0].size[dimension] - currentValue // 6.4
      return { min: min - clearSize, max: max - clearSize }
    }
  }))
  .views((self) => ({
    get size() {
      const size = new THREE.Vector3()
      self.boundings.getSize(size)
      return size
    }
  }))
  .actions((self) => ({
    logUpdate(date = new Date().valueOf(), patch = false) {
      self.updatedAt = date as any
    }
  }))

const StatefullProject = ProjectModel.props({
  deleted: types.optional(types.boolean, false)
})
  .volatile((self) => ({
    state: undefined as undefined | 'pending' | 'done' | 'error'
  }))
  .actions((self) => ({
    delete() {
      self.deleted = true
    },
    save() {},
    load() {}
  }))

export const Project = () => StatefullProject
